import React, { ReactNode, useRef } from "react";
import { MouseOver, MouseOverProps } from "@me8eon/components";



export const SimpleMouseOver: MouseOver = ({ children, style, changeColour, linkHover = "blue" }: MouseOverProps) => {
    const PreserveColour = useRef<string | null>(null);

    const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
        const elem = e.currentTarget.firstElementChild as HTMLElement | null;
        if (elem && elem.style.color) {
            PreserveColour.current = elem.style.color;
            elem.style.color = linkHover;
            changeColour?.(linkHover);
        }
    };

    const handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
        const elem = e.currentTarget.firstElementChild as HTMLElement | null;
        const colour = PreserveColour.current;
        if (elem && colour) {
            elem.style.color = colour;
            changeColour?.(colour);
        }
    };

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ ...style }}>
            {children}
        </div>
    );
};
